export default __webpack_public_path__ + "static/media/CivilEng_BG-01-1.a60530aa.png";